import { render, staticRenderFns } from "./WorkShopDetailView.vue?vue&type=template&id=1f4ec1c2"
import script from "./WorkShopDetailView.vue?vue&type=script&lang=js"
export * from "./WorkShopDetailView.vue?vue&type=script&lang=js"
import style0 from "./WorkShopDetailView.vue?vue&type=style&index=0&id=1f4ec1c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports